import React from 'react';
type DecorProps = {
  className?: string;
};

/** Doble hélice de ADN — decorativa. */
export function DnaHelix({
  className = ''
}: DecorProps) {
  const rungs = Array.from({
    length: 9
  }, (_, index) => 24 + index * 19);
  return <svg viewBox="0 0 80 200" fill="none" aria-hidden="true" className={className} data-id="element-21" data-mp="3fxfwcv23paiu">
      <path d="M22 4C58 30 58 58 22 84c-36 26-36 54 0 80 36 26 36 26 0 32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.75" data-id="element-22" data-mp="3kvr7ra81nt36" />
      <path d="M58 4C22 30 22 58 58 84c36 26 36 54 0 80-36 26-36 26 0 32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.45" data-id="element-23" data-mp="3ayuvctf0ymtc" />
      {rungs.map(y => <line key={y} x1="24" y1={y} x2="56" y2={y} stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.35" data-id="element-24" data-mp="2x9az86fy8nt0" />)}
    </svg>;
}

/** Árbol transgeneracional — decorativo. */
export function TreeOfLife({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-25" data-mp="2s8woggmyqzra">
      <path d="M60 196v-92" stroke="currentColor" strokeWidth="4" strokeLinecap="round" opacity="0.75" data-id="element-26" data-mp="2p71xokwz9n82" />
      <path d="M60 150c-14 10-22 24-24 42M60 150c14 10 22 24 24 42M60 166c-8 6-14 16-16 30M60 166c8 6 14 16 16 30" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" opacity="0.4" data-id="element-27" data-mp="2k8qma5r1b4nq" />
      <path d="M60 108c-16-8-26-20-30-34M60 108c16-8 26-20 30-34M60 88c-12-6-20-16-24-28M60 88c12-6 20-16 24-28" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" opacity="0.5" data-id="element-28" data-mp="2u6oawuct33gv" />
      <circle cx="60" cy="52" r="30" fill="currentColor" opacity="0.28" data-id="element-29" data-mp="21hprzv0uzxai" />
      <circle cx="32" cy="70" r="17" fill="currentColor" opacity="0.22" data-id="element-30" data-mp="21fmpwcmfmdpf" />
      <circle cx="88" cy="70" r="17" fill="currentColor" opacity="0.22" data-id="element-31" data-mp="2f9xix65gou1a" />
      <circle cx="60" cy="24" r="12" fill="currentColor" opacity="0.3" data-id="element-32" data-mp="2ai5qeq2qwe8i" />
    </svg>;
}

/** Silueta con puntos energéticos — decorativa. */
export function BodySilhouette({
  className = ''
}: DecorProps) {
  const points = [46, 66, 88, 110, 132];
  return <svg viewBox="0 0 80 200" fill="none" aria-hidden="true" className={className} data-id="element-33" data-mp="1ip5d5hhzvspp">
      <circle cx="40" cy="24" r="14" fill="currentColor" opacity="0.35" data-id="element-34" data-mp="3hvgf57q9gyhx" />
      <path d="M40 42c-14 0-22 8-22 22v34c0 8 2 14 5 20l-6 56c0 5 10 6 12 1l11-40 11 40c2 5 12 4 12-1l-6-56c3-6 5-12 5-20V64c0-14-8-22-22-22Z" fill="currentColor" opacity="0.24" data-id="element-35" data-mp="3mu18cn73ihwv" />
      {points.map(y => <circle key={y} cx="40" cy={y} r="4.5" fill="currentColor" opacity="0.7" data-id="element-36" data-mp="egg6e9q024z" />)}
      <path d="M40 40v100" stroke="currentColor" strokeWidth="1.6" opacity="0.4" strokeDasharray="4 6" data-id="element-37" data-mp="2yxnbu4bq6mk0" />
    </svg>;
}

/** Rama con hojas — decorativa. */
export function LeafSprig({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-38" data-mp="38ua0z5b33zru">
      <path d="M60 196V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" data-id="element-39" data-mp="3duo6ogp7qxmp" />
      {[0, 1, 2, 3, 4].map(index => {
      const y = 44 + index * 30;
      return <g key={index} data-id="element-40" data-mp="t45hksqce474">
            <path d={`M60 ${y} C40 ${y - 16} 20 ${y - 10} 12 ${y + 6} C30 ${y + 18} 50 ${y + 12} 60 ${y}Z`} fill="currentColor" opacity="0.35" data-id="element-41" data-mp="t3e0emxhs90d" />
            <path d={`M60 ${y + 14} C80 ${y - 2} 100 ${y + 4} 108 ${y + 20} C90 ${y + 32} 70 ${y + 26} 60 ${y + 14}Z`} fill="currentColor" opacity="0.22" data-id="element-42" data-mp="2dletkrxxzrwd" />
          </g>;
    })}
      <circle cx="60" cy="16" r="7" fill="currentColor" opacity="0.5" data-id="element-43" data-mp="23v3kkqzeisim" />
    </svg>;
}

/** Mandala de integración — decorativo. */
export function Mandala({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className} data-id="element-44" data-mp="1tza3cuaqmaui">
      {Array.from({
      length: 8
    }, (_, index) => <ellipse key={index} cx="50" cy="24" rx="9" ry="20" fill="currentColor" opacity="0.32" transform={`rotate(${index * 45} 50 50)`} data-id="element-45" data-mp="1pyq5foicb37b" />)}
      <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="1.6" opacity="0.45" data-id="element-46" data-mp="1fyz6namqy21f" />
      <circle cx="50" cy="50" r="8" fill="currentColor" opacity="0.7" data-id="element-47" data-mp="3fc3dnotkpbdp" />
    </svg>;
}